import React, { PureComponent } from "react";
import _ from "lodash";
import {
  Card,
  CardBody,
  Col,
  Button,
  ButtonToolbar,
  Container,
  Row,
  Table,
  Modal,
} from "reactstrap";
import { Field, reduxForm } from "redux-form";
import "./styles.css";
import { withTranslation } from "react-i18next";
import PropTypes from "prop-types";
import XLSX from "xlsx";
import { MDBDataTable } from "mdbreact";
import * as FileSaver from "file-saver";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faDownload, faSyncAlt } from "@fortawesome/free-solid-svg-icons";
import Util from "../../../Common/util";
import API from "../../../Common/api";

import "./styles.css";
import LoadingOverlay from "react-loading-overlay";
import styled, { css } from "styled-components";
import DatePicker from "react-datepicker";
import { PostAddTwoTone } from "@material-ui/icons";
import DarkBackground from '../../../Common/backgroundLoader';
import {addAnalytics, paginationAnalytics} from '../../../Common/analytics';
import exportToCSV from '../../../Common/exportcsv';



var url = window.location.hostname;
var port = window.location.port;
var From_Date_val;
var to_Date_val;
const Heading = [
    [
      'warehouse',  'Outlet OrderNo', 'Retailer Code' ,'Retailer Hul Code'  ,'Retailer Name', 'Sku7_Code',  'Salesman Code',  'pl_group', 'Jarvis Product Id',  'Area Code','BasePack Code',  'Distributor Code', 'Distributor Name', 'Put Inner Qty',  'Put Loose Qty',  'Put Outer Qty',  'Order Qty',  'UPC',  'MRP',  'PKD',  'Weight', 'Value',  'Status', 'Tur','Order Date', 'Loading Date', 'Added On', 'Product',  'Product Category', 'Product Sub Category', 'Product Division', 'Beat Name',  'Beat Seq','sum of net sales cases',  'sum of net sales kgs', 'sum of net sales qty', 'sum of net sales value', 'sum of other discount',  'sum of scheme discount', 'sum of tax percentage' 
    ],
  ];


class HorizontalForm extends PureComponent {
  static propTypes = {
    t: PropTypes.func.isRequired,
    handleSubmit: PropTypes.func.isRequired,
    reset: PropTypes.func.isRequired,
  };

  constructor() {
    super();
    this.createCookie = this.createCookie.bind(this);
    this.accessCookie = this.accessCookie.bind(this);
    this.fetchBifurcationData = this.fetchBifurcationData.bind(this);
    this.indexOfExt = this.indexOfExt.bind(this);
    this.processData = this.processData.bind(this);

    this.state = {
      filtered_orderData: [],
      loading_overlay: false,
      showPassword: false,
      file: {},
      data: [],
      cols: [],
      dummyFile: {},
      showInvalidItem: false,
      fileNameVal: "masterFile",
      showRowDataError: false,
      invalidItemList: [],
      selectedOption: null,
      posts: [],
      ErrorRowData: [],
      loading: false,

      isLoading: true,
      showFetchBinData: true,
      show_process_data: true,

      // from_date: "",
      // to_date: "",

      tableRows: [],
      value: "",
      error: "",
      value: "select",
      selectedFileType: "",
      selectedSubGroup: "",
      error_modal : false,
    };
  }

  showPassword = (e) => {
    e.preventDefault();
    this.setState((prevState) => ({ showPassword: !prevState.showPassword }));
  };

  componentDidMount() {
    // this.fetchInventoryData();
  }

  componentWillMount() {
    if (window.location.port == 8091 || window.location.port === ":8090") {
      port = ":8090";
    } else if (
      window.location.port == 8098 ||
      window.location.port === ":8098"
    ) {
      port = ":8099";
    } else {
      port = ":8088";
    }

    if (url === "localhost") {
      url = "15.206.34.41" + ":8088";
    } else {
      url = window.location.hostname + port;
    }

    var cookieUsername = this.getCookie("token");
    var location = this.getCookie("selectedLocation");
    var username = this.accessCookie("token");
    this.setState({
      userName: cookieUsername,
      selectedLocation: location,
    });

    localStorage.setItem("userName", username);
  }

  convertDate = (inputFormat) => {
    function pad(s) {
      return s < 10 ? "0" + s : s;
    }
    var d = new Date(inputFormat);
    return [d.getFullYear(), pad(d.getMonth() + 1), pad(d.getDate())].join("-");
  };
  FromDateChange = (date) => {
    this.setState({
      fromdate: date,
      showFromErr: false,
    });
    if (date) {
      From_Date_val = this.convertDate(date);
    } else {
      this.setState({
        fromdate: "",
      });
      From_Date_val = "";
    }
  };

  ToDateChange = (date) => {
    this.setState({
      todate: date,
      showToErr: false,
    });
    if (date) {
      to_Date_val = this.convertDate(date);
    } else {
      this.setState({
        todate: "",
      });
      to_Date_val = "";
    }
  };

  createCookie(cookieName, cookieValue, daysToExpire) {
    var date = new Date();
    date.setTime(date.getTime() + 1 * 24 * 60 * 60 * 1000);
    document.cookie =
      cookieName + "=" + cookieValue + "; expires=" + date.toGMTString();
  }

  accessCookie(cookieName) {
    var name = cookieName + "=";
    var allCookieArray = document.cookie.split(";");
    for (var i = 0; i < allCookieArray.length; i++) {
      var temp = allCookieArray[i].trim();
      if (temp.indexOf(name) == 0)
        return temp.substring(name.length, temp.length);
    }
    return "";
  }

  getCookie(cname) {
    var name = cname + "=";
    var decodedCookie = decodeURIComponent(document.cookie);
    var ca = decodedCookie.split(";");
    for (var i = 0; i < ca.length; i++) {
      var c = ca[i];
      while (c.charAt(0) == " ") {
        c = c.substring(1);
      }
      if (c.indexOf(name) == 0) {
        return c.substring(name.length, c.length);
      }
    }
    return "";
  }

  indexOfExt(list, item) {
    var len = list.length;

    for (var i = 0; i < len; i++) {
      var keys = Object.keys(list[i]);
      var flg = true;
      for (var j = 0; j < keys.length; j++) {
        var value = list[i][keys[j]];
        if (item[keys[j]] !== value) {
          flg = false;
        }
      }
      if (flg == true) {
        return i;
      }
    }
    return -1;
  }

  handleSubGroupChange = (e) => {
    const value = e.target.value;
    this.setState({
      selectedSubGroup: value,
    });
  };

  fetchBifurcationData() {

    if (From_Date_val === undefined && to_Date_val === undefined && this.state.selectedSubGroup == ""){
      this.setState({error_modal : true})
    }
    else {
      this.setState({
        showFetchBinData: true,
        showFetchBaseData: false,
        showFetchProductData: false,
        showFetchTesterData: false,
        loading_overlay: true,
      });

    const payload = {
      // location: this.state.selectedLocation,

      request_type: "view",

      group_id: this.state.selectedSubGroup,
      to_date: to_Date_val,
      from_date: From_Date_val,
      // screen_type: "cld_dispatch_report",
    };
    addAnalytics('Report', 'View Secondary Bifurcation Report', payload);
    API.post("/download/bifurcation-report/", { param: payload })
      .then((response) => response.data)

      .then((data) => {
        // this.setState({ posts: data.data, filtered_orderData: data.data });
        this.setState ({tableRows: this.assemblePosts(data.data),});
      })

      .then(async () => {
        this.setState({  isLoading: false });

        console.log(this.state.tableRows);
      });
  }}
  errorModaltoggle = () => {
    this.setState({error_modal :false})
  }
  filterData = (evt) => {
    if (evt == "") {
      this.setState({ filtered_orderData: this.state.posts });
    } else {
      var value = this.state.posts.filter((val) => {
        return Object.keys(val).some((key) => {
          var data = "";
          if (val[key] == null) {
            data = "";
          } else {
            data = val[key];
          }

          return data.toString().toLowerCase().includes(evt.toLowerCase());
        });
      });

      this.setState({
        filtered_orderData: value,
      });
    }
  };

  assemblePosts = (data) => {
    let posts = data.map((post) => {
      var status = "";
      if (post.status == true) {
        status = "Active";
      } else {
        status = " Not Active";
      }
      return {
        warehouse: post.warehouse,
        outlet_order_no: post.outlet_order_no,
        retailer_code: post.retailer_code,
        retailer_hul_code: post.retailer_hul_code,
        retailer_name: post.retailer_name,
        sku7_code: post.sku7_code,
        salesman_code: post.salesman_code,
        pl_group: post.pl_group,
        lb_sku_id: post.lb_sku_id,
        area_code: post.area_code,
        base_pack_code: post.base_pack_code,
        distributor_code: post.distributor_code,
        distributor_name: post.distributor_name,
        put_inner_qty: post.put_inner_qty,
        put_loose_qty: post.put_loose_qty,
        put_outer_qty: post.put_outer_qty,
        order_qty: post.order_qty,
        upc: post.upc,
        mrp: post.mrp,
        pkd: post.pkd,
        weight: post.weight,
        value: post.value,
        status: post.status,
        tur: post.tur,
        order_date: post.order_date,
        loading_date: post.loading_date,
        added_on: post.added_on,
        product: post.product,
        product_category: post.product_category,
        product_sub_category: post.product_sub_category,
        product_division: post.product_division,
        beat_name: post.beat_name,
        beat_seq: post.beat_seq,
        sum_of_net_sales_cases: post.sum_of_net_sales_cases,
        sum_of_net_sales_kgs: post.sum_of_net_sales_kgs,
        sum_of_net_sales_qty: post.sum_of_net_sales_qty,
        sum_of_net_sales_value: post.sum_of_net_sales_value,
        sum_of_other_discount: post.sum_of_other_discount,
        // sum_of_sales_free_qty: post.sum_of_sales_free_qty,
        sum_of_scheme_discount: post.sum_of_scheme_discount,
        sum_of_tax_percentage: post.sum_of_tax_percentage,
        // asn_reference: post.asn_reference,
        
        // batch_code: post.batch_code,
        
        
        // cbu_code: post.cbu_code,
        // cp_flag: post.cp_flag,
        // delivery_line_number: post.delivery_line_number,
        
        // location: post.location
        
        // pricelist_group: post.pricelist_group,
        
        // rs_name: post.rs_name,
        
        // unique_id: post.unique_id,
       
        
        // vehicle: post.vehicle,
        
        
      };
    });

    this.setState({
      loading_overlay: false,
      filtered_orderData : posts,
      posts              : posts,
    });

    return posts;
  };

  processData() {
    this.setState({
      loading: true,
    });
  }

  render() {
    console.log(this.state.showInvalidItem);

    const data = {
      columns: [
        { label: "warehouse", field: "warehouse", sort: "asc", width: 130 },
        { label: "Outlet OrderNo", field: "outlet_order_no", sort: "asc", width: 150 },
        { label: "Retailer Code", field: "retailer_code", sort: "asc", width: 150 },
        { label: "Retailer Hul Code", field: "retailer_hul_code", sort: "asc", width: 150 },
        { label: "Retailer Name", field: "retailer_name", sort: "asc", width: 150 },
        { label: "Sku7_Code", field: "sku7_code", sort: "asc", width: 150 },
        { label: "Salesman Code", field: "salesman_code", sort: "asc", width: 150 },
        { label: "pl_group", field: "pl_group", sort: "asc", width: 150 },
        { label: "Jarvis Product Id", field: "lb_sku_id", sort: "asc", width: 150 },
        { label: "Area Code", field: "area_code", sort: "asc", width: 150 },
        { label: "BasePack Code", field: "base_pack_code", sort: "asc", width: 150 },
        { label: "Distributor Code", field: "distributor_code", sort: "asc", width: 150 },
        { label: "Distributor Name", field: "distributor_name", sort: "asc", width: 150 },
        { label: "Put Inner Qty", field: "put_inner_qty", sort: "asc", width: 70 },
        { label: "Put Loose Qty", field: "put_loose_qty", sort: "asc", width: 70 },
        { label: "Put Outer Qty", field: "put_outer_qty", sort: "asc", width: 70 },
        { label: "Order Qty", field: "order_qty", sort: "asc", width: 70 },
        { label: "UPC", field: "upc", sort: "asc", width: 110 },
        { label: "MRP", field: "mrp", sort: "asc", width: 70 },
        { label: "PKD", field: "pkd", sort: "asc", width: 70 },
        { label: "Weight", field: "weight", sort: "asc", width: 120 },
        { label: "Value", field: "value", sort: "asc", width: 120 },
        { label: "Status", field: "status", sort: "asc", width: 70 },
        { label: "Tur", field: "tur", sort: "asc", width: 120 }, 
        { label: "Order Date", field: "order_Date", sort: "asc", width: 110 },
        { label: "Loading Date", field: "loading_date", sort: "asc", width: 120 },
        { label: "Added On", field: "Added_on", sort: "asc", width: 120 },
        { label: "Product", field: "product", sort: "asc", width: 120 },
        { label: "Product Category", field: "product_category", sort: "asc", width: 120 },
        { label: "Product Sub Category", field: "product_sub_category", sort: "asc", width: 120 },
        { label: "Product Division", field: "product_division", sort: "asc", width: 120 },
        { label: "Beat Name", field: "beat_name", sort: "asc", width: 120 },
        { label: "Beat Seq", field: "beat_seq", sort: "asc", width: 120 },
        { label: "sum of net sales cases", field: "sum_of_net_sales_cases", sort: "asc", width: 120 },
        { label: "sum of net sales kgs", field: "sum_of_net_sales_kgs", sort: "asc", width: 120 },
        { label: "sum of net sales qty", field: "sum_of_net_sales_qty", sort: "asc", width: 120 },
        { label: "sum of net sales value", field: "sum_of_net_sales_value", sort: "asc", width: 120 },
        { label: "sum of other discount", field: "sum_of_other_discount", sort: "asc", width: 120 },
        { label: "sum of scheme discount", field: "sum_of_scheme_discount", sort: "asc", width: 120 },
        { label: "sum of tax percentage", field: "sum_of_tax_percentage", sort: "asc", width: 120 },
      ],

      rows: this.state.tableRows,
    };
    return (
      <Col xl={12}>
        {this.state.loading_overlay && (
          <DarkBackground disappear={this.state.loading_overlay}>
            <LoadingOverlay
              active={this.state.loading_overlay}
              // spinner={<BounceLoader />}
              spinner={this.state.loading_overlay}
              text={this.state.loadingText}
              style={{ textAlign: "center", alignItem: "center" }}
            ></LoadingOverlay>
          </DarkBackground>
        )}
        <Card>
          <CardBody
            style={{
              paddingTop: 10,
              height: 80,
              paddingBottom: 0,
              marginBottom: "-13px",
            }}
          >
            <form className="form">
              {/* <div
                className="form__form-group col-xl-2"
                style={{
                  display: "inline-block",
                  marginBottom: "0px",
                  marginRight: 5,
                  marginTop: 4,
                }}
              > */}
              <div
                style={{
                  width: "15%",
                  marginBottom: "0px",
                  float: "left",
                  marginRight: 5,
                }}
              >
                <DatePicker
                  selected={this.state.fromdate}
                  onChange={this.FromDateChange}
                  className="ledger_fromdate"
                  placeholderText="From Date"
                  format="yyyy-MM-dd"
                />
                {this.state.showFromErr && (
                  <span style={{ color: "red", fontSize: 11 }}>
                    Please Select From Date
                  </span>
                )}
              </div>
              <div
                style={{
                  width: "15%",
                  marginBottom: "0px",
                  float: "left",
                  marginRight: 5,
                }}
              >
                <DatePicker
                  selected={this.state.todate}
                  onChange={this.ToDateChange}
                  className="ledger_todate"
                  placeholderText="To Date"
                />
                {this.state.showToErr && (
                  <span style={{ color: "red", fontSize: 11 }}>
                    Please Select To Date
                  </span>
                )}
              </div>

              <div
                style={{
                  width: "15%",
                  marginBottom: "0px",
                  float: "left",
                  marginRight: 5,
                }}
              >
                <div
                  className="form__form-group-field"
                  style={{ display: "contents" }}
                >
                  <input
                    type="text"
                    style={{
                      border: "1px solid #B0ADAD",
                      backgroundColor: "white",
                    }}
                    className="form-control group_text1"
                    placeholder="Enter Group Id"
                    onChange={this.handleSubGroupChange}
                  />
                </div>
              </div>

              <div
                style={{
                  width: "9%",
                  marginBottom: "0px",
                  marginLeft: "60px",
                  float: "left",
                }}
              >
                <ButtonToolbar className="form__button-toolbar">
                  <Button
                    className="btn-sm button_enable "
                    style={{
                      fontWeight: "normal",
                      textTransform: "capitalize",
                      borderRadius: 5,
                      backgroundColor: "#70bbfd",
                      color: "#fff",
                      padding: "5px 25px",
                      fontSize: "14px",
                    }}
                    id="button_enable"
                    onClick={() => this.fetchBifurcationData()}
                  >
                    {this.state.loading && (
                      <i
                        className="fa fa-refresh fa-spin"
                        style={{ marginRight: "5px" }}
                      />
                    )}
                    View
                  </Button>
                </ButtonToolbar>
              </div>
              <div style={{ width: "6%", marginBottom: "0px", float: "left" }}>
                <Button
                  type="button"
                  className="btn btn-primary-outline"
                  style={{
                    cursor: this.state.btnDisabled ? "pointer" : "pointer",
                    backgroundColor: this.state.btnDisabled
                      ? "#FFFFFF"
                      : "#FFFFFF",
                  }}
                  id="button_enable"
                  // onClick={this.downloadReport}
                >
                  {/* <img
                    src={require("../../../../images/download.png")}
                    onClick={this.state.downloadError}
                  /> */}
                  <img
                    src={require("../../../../images/download.png")}
                    onClick={(e) =>
                      exportToCSV(
                        this.state.filtered_orderData,
                        "Bifurcation Report", Heading
                      )
                    }
                  />
                </Button>
              </div>
            </form>
          </CardBody>
          {this.state.showFetchBinData && (
            <CardBody style={{ marginTop: 20 }}>
              <div
                className="table_header"
                style={{ borderBottomWidth: "0px" }}
              >
                <h4
                  style={{
                    fontWeight: "bold",
                    width: "80%",
                    paddingTop: 10,
                    float: "left",
                  }}
                  className="subhead red-text"
                >
                  Reports
                </h4>
              </div>
              <hr style={{ marginTop: "30px", marginBottom: "0px" }} />
              <MDBDataTable
                striped
                bordered
                scrollX
                sortable={false}
                onPageChange = {(pageNumber) => paginationAnalytics(pageNumber.activePage,pageNumber.pagesAmount, 'Secondary Bifurcation Report', 'datatable_pagination_change' )}
                hover
                onSearch={this.filterData}
                data={data}
                style={{ textAlign: "left",margin : "0px",padding : "0px" }}
              />
            </CardBody>
          )}
          <Modal isOpen={this.state.error_modal} >
          <div className="modal__header">
            <button
              className="lnr lnr-cross modal__close-btn"
              type="button"
              style={{ right: 15 }}
              
            />
          </div>
          <div
            className="modal__body"
            style={{ paddingTop: 55, paddingBottom: 20 }}
          >
            <span
              className="lnr lnr-thumbs-down modal__title-icon"
              // className="lnr lnr-cross modal__close-btn"
              style={{ color: "red" ,fontSize : "35px"}}
            />
            <h4>Please select date or Group Id</h4>
          </div>
          <ButtonToolbar className="modal__footer">
            <Button
              style={{ backgroundColor: "#24d6a3", color: "#fff" }}
              className="modal_ok"
              // onClick={this.SuccessConfirmoktoggle}
              onClick={this.errorModaltoggle}
            >
              Ok
            </Button>
          </ButtonToolbar>
        </Modal>
        </Card>
      </Col>
    );
  }
}

export default reduxForm({
  form: "Upload Master", // a unique identifier for this form
})(withTranslation("common")(HorizontalForm));
